/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InternalPolicyItem, PolicyDetailType } from "#/apis/infra/getPolicies";
import { PoliciesState } from "./types";

const initialState: PoliciesState = {
  list: {
    data: null,
    loading: false,
    error: null,
  },
  detail: {
    data: null,
    loading: false,
    error: null,
  },
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const policiesSlice = createSlice({
  name: "policies",
  initialState,
  reducers: {
    getPolicies: (state, _: PayloadAction<{ accessToken: string; period: number; timezone?: string }>) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getPoliciesSuccess: (state, action: PayloadAction<InternalPolicyItem[]>) => {
      state.list.data = action.payload;
      state.list.loading = false;
      state.list.error = null;
    },
    getPoliciesFailure: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },
    getPolicyDetail: (state, _: PayloadAction<{ accessToken: string; policyId: string }>) => {
      state.detail.loading = true;
      state.detail.error = null;
    },
    getPolicyDetailSuccess: (state, action: PayloadAction<PolicyDetailType>) => {
      state.detail.data = action.payload;
      state.detail.loading = false;
      state.detail.error = null;
    },
    getPolicyDetailFailure: (state, action: PayloadAction<string>) => {
      state.detail.loading = false;
      state.detail.error = action.payload;
    },
    // eslint-disable-next-line max-len
    updatePolicyRules: (state, _: PayloadAction<{ accessToken: string; policyId: string; rulesList: string[] }>) => {
      state.detail.loading = true;
      state.detail.error = null;
    },
    updatePolicyRulesSuccess: (state, action: PayloadAction<PolicyDetailType>) => {
      state.detail.data = action.payload;
      state.detail.loading = false;
      state.detail.error = null;
    },
    updatePolicyRulesFailure: (state, action: PayloadAction<string>) => {
      state.detail.loading = false;
      state.detail.error = action.payload;
    },
    // eslint-disable-next-line max-len
    updatePolicy: (state, _: PayloadAction<{ accessToken: string; policyId: string; policyName: string; description: string; riskLevel: number; policyType?: string; rulesList?: string[]; enabled?: boolean }>) => {
      state.detail.loading = true;
      state.detail.error = null;
    },
    updatePolicySuccess: (state, action: PayloadAction<PolicyDetailType>) => {
      state.detail.data = action.payload;
      state.detail.loading = false;
      state.detail.error = null;
    },
    updatePolicyFailure: (state, action: PayloadAction<string>) => {
      state.detail.loading = false;
      state.detail.error = action.payload;
    },
    // eslint-disable-next-line max-len
    createPolicy: (state, _: PayloadAction<{ accessToken: string; policyName: string; description: string; riskLevel: number; serviceTokenIds: string[]; policyType: string; rulesList?: string[]; enabled?: boolean }>) => {
      state.list.loading = true;
      state.list.error = null;
    },
    createPolicySuccess: (state) => {
      state.list.loading = false;
      state.list.error = null;
    },
    createPolicyFailure: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },
    deletePolicy: (state, _: PayloadAction<{ accessToken: string; policyId: string; policyName: string }>) => {
      state.list.loading = true;
      state.list.error = null;
    },
    deletePolicySuccess: (state) => {
      state.list.loading = false;
      state.list.error = null;
      state.detail.data = null;
    },
    deletePolicyFailure: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },
  },
});

export const {
  getPolicies,
  getPoliciesSuccess,
  getPoliciesFailure,
  getPolicyDetail,
  getPolicyDetailSuccess,
  getPolicyDetailFailure,
  updatePolicyRules,
  updatePolicyRulesSuccess,
  updatePolicyRulesFailure,
  updatePolicy,
  updatePolicySuccess,
  updatePolicyFailure,
  createPolicy,
  createPolicySuccess,
  createPolicyFailure,
  deletePolicy,
  deletePolicySuccess,
  deletePolicyFailure,
} = policiesSlice.actions;

export default policiesSlice.reducer;
